import * as React from "react";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  "data-testid": string; // Made mandatory for automation testing
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
  // For checkbox and radio inputs, don't apply the default text input styling
    const isCheckboxOrRadio = type === 'checkbox' || type === 'radio';
    const shouldNormalizeValue =
      !isCheckboxOrRadio &&
      type !== 'file' &&
    Object.prototype.hasOwnProperty.call(props, 'value');
    const normalizedProps = shouldNormalizeValue && props.value == null
      ? { ...props, value: '' }
      : props;
    
    // ECOPD #53: switched the default enabled background from `bg-surface`
    // to `bg-background` so inputs visually separate from the surrounding
    // card / modal (which are themselves `bg-surface`). Updated to use
    // `bg-surface` (replacing the undefined `bg-surface-secondary` token)
    // so all form fields are visually consistent inside modals and cards in
    // both light (#FFFFFF) and dark (#262626) mode.
    // Disabled inputs keep `bg-surface-alt` + 50 % opacity so the disabled
    // affordance still looks distinctly darker than the enabled state.
    const baseClasses = isCheckboxOrRadio
      ? className || ''
      : `block w-full h-[36px] border border-border-strong rounded-[4px] py-[6px] px-[10px] text-[14px] text-text bg-surface placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-surface-alt ${className || ''}`;
    
    return (
      <input
      type={type}
        className={baseClasses}
        ref={ref}
      {...normalizedProps}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
